import React, { useState } from 'react';
import { Layout, Typography, Space } from 'antd';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

export default function FooterBar() {
    const [year] = useState(new Date().getFullYear());

    return (
        <AntFooter style={{
            background: '#f0f2f5',
            borderTop: '1px solid #d9d9d9',
            padding: '16px 50px'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    <div style={{ marginBottom: '12px' }}>
                        <Text type="secondary">
                            © {year}{' '}
                            <Link
                                href=""
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                
                            </Link>. All rights reserved. | v0.0.3
                        </Text>
                    </div>

                </div>
            </div>
        </AntFooter>
    );
}